import React from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow } from '@mui/material';
import { Skeleton } from '../../../../../../components';

const ProcessEventsTableSkeleton = ({ rows = 10, columns = 5 }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, idx) => (
        <TableRow key={idx}>
          {Array.from({ length: columns }).map((_, colIdx) => (
            <TableCell key={colIdx}>
              <Skeleton />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
};

ProcessEventsTableSkeleton.propTypes = {
  rows: PropTypes.number,
  columns: PropTypes.number,
};

export default ProcessEventsTableSkeleton;
